module.exports = __webpack_public_path__ + "static/Insect_Swarm-b50fc2394de97b02be1d307aa3316cb4.jpg";